import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {testIdProps} from '@github-ui/test-id-props'
import type {ShowModelPayload} from '../../../types'
import {VerifiedHTMLBox} from '@github-ui/safe-html/VerifiedHTML'

export function Evaluation() {
  const {modelEvaluation} = useRoutePayload<ShowModelPayload>()

  return (
    <>
      {modelEvaluation && (
        <VerifiedHTMLBox data-hpc html={modelEvaluation} className="tmp-p-3" {...testIdProps('evaluation-content')} />
      )}
    </>
  )
}
